module.exports = __webpack_public_path__ + "static/img/datacenter.46f1274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datacenter.jpg
// module id = mK5f
// module chunks = 2